import { createWebSocketRequest } from './utils';

/**
 * Get the user's watchlist
 * @returns {Promise<Array>} A promise that resolves with the user's watchlist instruments
 */
export const getUserWatchlist = () => {
  return createWebSocketRequest({
    eventName: 'get-watchlist-response',
    requestType: 'get-watchlist',
    dataValidator: (data) => {
      console.log('Watchlist response:', data);
      if (data.data && Array.isArray(data.data)) {
        return data.data;
      }
      return undefined;
    },
    errorMessage: 'Timeout waiting for watchlist'
  });
};

/**
 * Add an instrument to the user's watchlist
 * @param {string} instrumentId - The instrument ID to add to watchlist
 * @returns {Promise<Object>} A promise that resolves with the response data
 */
export const addToWatchlist = (instrumentId) => {
  // Validate parameter
  if (!instrumentId || typeof instrumentId !== 'string') {
    return Promise.reject(new Error('Invalid instrument ID provided for watchlist addition'));
  }

  return createWebSocketRequest({
    eventName: 'add-watchlist-response',
    requestType: 'add-watchlist',
    requestData: {
      data: {
        instrumentId: instrumentId
      }
    },
    dataValidator: (data) => {
      console.log('Add to watchlist response:', data);
      // Check for various success indicators
      if (data.success === true || 
          (data.data && data.data.success === true) ||
          data.data === 'success') {
        return data;
      }
      // If we reach here, throw error
      const errorMessage = data.message || data.error || 'Failed to add instrument to watchlist';
      throw new Error(errorMessage);
    },
    errorMessage: `Timeout waiting for add watchlist response for instrument: ${instrumentId}`
  });
};

/**
 * Remove an instrument from the user's watchlist
 * @param {string} instrumentId - The instrument ID to remove from watchlist
 * @returns {Promise<Object>} A promise that resolves with the response data
 */
export const removeFromWatchlist = (instrumentId) => {
  // Validate parameter
  if (!instrumentId || typeof instrumentId !== 'string') {
    return Promise.reject(new Error('Invalid instrument ID provided for watchlist removal'));
  }

  return createWebSocketRequest({
    eventName: 'remove-watchlist-response',
    requestType: 'remove-watchlist',
    requestData: {
      data: {
        instrumentId: instrumentId
      }
    },
    dataValidator: (data) => {
      console.log('Remove from watchlist response:', data);
      // Check for various success indicators
      if (data.success === true || 
          (data.data && data.data.success === true) ||
          data.data === 'success') {
        return data;
      }
      // If we reach here, throw error
      const errorMessage = data.message || data.error || 'Failed to remove instrument from watchlist';
      throw new Error(errorMessage);
    },
    errorMessage: `Timeout waiting for remove watchlist response for instrument: ${instrumentId}`
  });
}; 